import FormControl from "@mui/material/FormControl/FormControl";
import Grid from "@mui/material/Grid/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper/Paper";
import Select from "@mui/material/Select/Select";
import Typography from "@mui/material/Typography/Typography";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { socket } from "../../App";
import {
  DeleteMaintenanceTask,
  getenterpriseswithtypes,
} from "../../actions/machines";
import { setDashboardLoader } from "../../actions/ui";

import { getall } from "../../actions/notification";
import {
  GetEquipmentStream,
  getsitesareaeqs,
  getsitesareaeqs2,
  getallsitesareaeqs,
} from "../../actions/objects";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import NotificationCardItem from "./component/NotificationCardItem";
// let {machines}=[];
import LazyLoad from "react-lazyload";
import { makeStyles } from "tss-react/mui";

import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

import "247factorynet-packages/dist/index.css";
import SafeMachineCardItem from "../../components/SafeMachineCardItem";
import { Button } from "@mui/material";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import machineFallbackImage from "../../assets/machine-example.png";

import { hasMalfunction } from "../../shared-functions/notification";
import { EmptyState } from "../MachineOverviewPage/EmptyStat";
import { canUserPerformAction } from "../../shared-functions/userrights";
import { AddIcCallOutlined, Info } from "@mui/icons-material";
import {
  KPI_dummy_data,
  truncateWithEllipses,
  getRandomSubset,
} from "../../utils/helpers";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import InitialState from "./component/InitialState";
import { getNotificationTooltipAndColor } from "../../types";
import KPI from "../../components/KPI";
import { getKpisData } from "../../actions/kpis";
import { Tooltip } from "antd";
import { isArray } from "lodash";
import { useAccountMode } from "../../utils/accountMode";

const DEFAULT_FETTE_SITE_NODEID =
  "247fn://247uptime.io/ebae8cce-70e8-473c-9c66-0af87d99fe04";

const buildDashboardCollectionsFromAllSitesAreaEqs = (allSitesAreaEqs = []) => {
  const legalEntity = allSitesAreaEqs?.[0]?.data?.[0]?.legalentity;
  const sites = {};
  const areas = {};
  const equipmentpools = {};
  const equipments = {};

  if (Array.isArray(legalEntity?.hassite)) {
    legalEntity.hassite.forEach((siteEntry) => {
      const site = siteEntry?.site;
      if (!site?.nodeid) {
        return;
      }

      sites[site.nodeid] = site;

      if (Array.isArray(site.hasarea)) {
        site.hasarea.forEach((areaEntry) => {
          const area = areaEntry?.area;
          if (!area?.nodeid) {
            return;
          }

          areas[area.nodeid] = area;

          if (Array.isArray(area.hasequipment)) {
            area.hasequipment.forEach((equipmentEntry) => {
              const equipment = equipmentEntry?.equipment;
              if (equipment?.nodeid) {
                equipments[equipment.nodeid] = equipment;
              }
            });
          }
        });
      }
    });
  }

  if (Array.isArray(legalEntity?.hasequipmentpool)) {
    legalEntity.hasequipmentpool.forEach((poolEntry) => {
      const equipmentpool = poolEntry?.equipmentpool;
      if (!equipmentpool?.nodeid) {
        return;
      }

      equipmentpools[equipmentpool.nodeid] = equipmentpool;

      if (Array.isArray(equipmentpool.hasequipment)) {
        equipmentpool.hasequipment.forEach((equipmentEntry) => {
          const equipment = equipmentEntry?.equipment;
          if (equipment?.nodeid) {
            equipments[equipment.nodeid] = equipment;
          }
        });
      }
    });
  }

  return {
    sites,
    areas,
    equipmentpools,
    equipments,
  };
};

const getLocalizedNameValue = (name, language) => {
  if (!name) {
    return "";
  }

  if (typeof name === "string") {
    return name;
  }

  if (typeof name === "object") {
    return (
      name?.[language] ??
      name?.de ??
      name?.en ??
      name?.fr ??
      Object.values(name).find((value) => typeof value === "string") ??
      ""
    );
  }

  return "";
};

const getEquipmentCardImageSrc = (equipment) => {
  const equipmentImage = equipment?.image;
  const equipmentTypeImage = equipment?.hasequipmenttype?.[0]?.equipmenttype?.image;

  if (
    !isArray(equipmentImage) &&
    equipmentImage != null &&
    Object.keys(equipmentImage).length > 0 &&
    equipmentImage.fileid !== ""
  ) {
    return equipmentImage?.url;
  }

  if (
    !isArray(equipmentTypeImage) &&
    equipmentTypeImage != null &&
    Object.keys(equipmentTypeImage).length > 0 &&
    equipmentTypeImage.fileid !== ""
  ) {
    return equipmentTypeImage?.url;
  }

  return machineFallbackImage;
};

/*
 * Styles
 */
const useStyles = makeStyles()((theme) => ({
  elevatedSection: {
    ...Theme247.elevatedSection,
  },
  sectionHeader: {
    ...Theme247.sectionHeader,
  },
  moreFilterButton: {
    position: "relative",
    display: "inline-flex",
    marginLeft: theme.spacing(2),
    marginTop: -12,
  },
  formControlLabel: {
    ...Theme247.formControlLabel,
  },
  filterStyle: {
    width: 190,
    marginLeft: theme.spacing(3),
  },
  noMarginLeft: {
    marginLeft: 0,
  },
  buttonContainer: {
    textAlign: "right",
  },
  smallCheckbox: {
    ...Theme247.multiselectCheckbox,
  },
  itemcardGridHeadline: {
    ...Theme247.itemcardGridHeadline,
  },
  itemcardGrid: {
    ...Theme247.itemcardGrid,
  },
  itemcardGridSection: {
    ...Theme247.itemcardGridSection,
  },
  itemcardGridItem: {
    ...Theme247.itemcardGridItem,
  },
  itemcardButtonFooter: {
    ...Theme247.itemcardButtonFooter,
  },
}));
export default connect(
  ({
    data,
    isAuthUser,
    dashboardLoader,
    machines,
    ownProps,
    bellNotifications,
    streams,
    profile,
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
    subscribedEquipments,
    updateProfile,
    userProfile,
    allsitesareaseqs,
    kpis,
  }) => ({
    data,
    isAuthUser,
    dashboardLoader,
    machines,
    ownProps,
    bellNotifications,
    streams,
    profile,
    subscribedSites,
    subscribedAreas,
    subscribedEquipmentpools,
    subscribedEquipments,
    updateProfile,
    userProfile,
    allsitesareaseqs,
    kpis,
  }),
  {
    getall,
    GetEquipmentStream,
    getenterpriseswithtypes,
    getsitesareaeqs,
    setDashboardLoader,
    getallsitesareaeqs,
    getsitesareaeqs2,
    DeleteMaintenanceTask,
    getKpisData,
  }
)((props) => {
  const { prefixPath, isFette } = useAccountMode();
  let storungTypes = [0, 10, 11, 12];

  const navigate = useNavigate();
  const {
    bellNotifications,
    subscribedSites,
    subscribedAreas,
    subscribedEquipments,
    subscribedEquipmentpools,
  } = props;
  const accessDashboardCollections = useMemo(
    () => buildDashboardCollectionsFromAllSitesAreaEqs(props.allsitesareaseqs),
    [props.allsitesareaseqs]
  );
  const effectiveSubscribedSites = isFette
    ? subscribedSites
    : accessDashboardCollections.sites;
  const effectiveSubscribedAreas = isFette
    ? subscribedAreas
    : accessDashboardCollections.areas;
  const effectiveSubscribedEquipmentpools = isFette
    ? subscribedEquipmentpools
    : accessDashboardCollections.equipmentpools;
  const effectiveSubscribedEquipments = isFette
    ? subscribedEquipments
    : accessDashboardCollections.equipments;
  const language = useStore().getState().language;
  const i18n = useStore().getState().i18n;
  const { classes } = useStyles();
  const [Title, setTitle] = useState(i18n.sites);

  const filterTimerangeValues = [
    { value: "all", label: i18n.no_time_range_selected },
    { value: "today", label: i18n.today },
    { value: "week", label: i18n.week },
    { value: "month", label: i18n.month },
  ];

  var equipmentpools,
    sites,
    areas,
    equipments = undefined;

  const [anchorEl, setanchorEl] = useState(null);
  const [open, setopen] = useState(false);
  const [filterAreas, setfilterAreas] = useState(["all"]);
  const [filterMachineparks, setfilterMachineparks] = useState(["all"]);
  const [machinesToDisplay, setmachinesToDisplay] = useState(false);
  const [StorungCounter, setStorungCounter] = useState(0);
  const [AuffCounter, setAuffCounter] = useState(0);
  const [NotizCounter, setNotizCounter] = useState(0);
  const [WartungenCounter, setWartungenCounter] = useState(0);
  const [poolsToDisplay, setpoolsToDisplay] = useState([]);
  const [poolsForNotifications, setpoolsForNotifications] = useState();
  const [StorungUnReadCounter, setStorungUnReadCounter] = useState();
  const [AuffUnReadCounter, setAuffUnReadCounter] = useState();
  const [NotizUnReadCounter, setNotizUnReadCounter] = useState();
  const [WartungenUnReadCounter, setWartungenUnReadCounter] = useState();
  const [storungCross, setstorungCross] = useState(false);
  const [auffCross, setauffCross] = useState(false);
  const [notizCross, setnotizCross] = useState(false);
  const [wartungenCross, setwartungenCross] = useState(false);
  const [FilterValue, setFilterValue] = useState(); // s==>247fn://247uptime.io/322caee7-a999-4455-95ce-6ee81e9d6003
  const [ApplyPoolsFilter, setApplyPoolsFilter] = useState(false);
  const [ApplyAreasFilter, setApplyAreasFilter] = useState(true);
  const [FilterTimerange, setFilterTimerange] = useState(["all"]);
  const [displayL2, setDisplayL2] = useState(true);
  const [selectedSiteNodeId, setSelectedSiteNodeId] = useState();
  const [selectedAreaNodeId, setSelectedAreaNodeId] = useState();
  const [selectedPoolNodeId, setSelectedPoolNodeId] = useState();
  const [localKpis, setLocalKpis] = useState([]);
  const hasAppliedDefaultSite = useRef(false);
  const renderSectionAction = (sectionMeta) => {
    if (typeof props.renderSectionAction === "function") {
      return props.renderSectionAction(sectionMeta);
    }

    return props.sectionAction ?? null;
  };

  const [has_equipment, setHas_Equipment] = useState([]);

  /* async function processLoadSitesData(data) {

        equipmentpools = new Map();
        sites = new Map();
        areas = new Map();
        equipments = new Map();

        //get all subscribed sites, areas and equipments

        if (data[0]?.data?.length > 0) {

            for (const equipmentpoolItem of data[0]?.data[0]?.legalentity

                ?.hasequipmentpool) {

                equipmentpools.set(

                    equipmentpoolItem.equipmentpool.nodeid,

                    equipmentpoolItem.equipmentpool

                );
                if (equipmentpoolItem?.equipmentpool?.hasequipment != undefined) {
                    for (const equipmentItem of equipmentpoolItem?.equipmentpool?.hasequipment) {
                        equipments.set(equipmentItem.equipment.nodeid, equipmentItem.equipment

                        );

                    }
                }


            }

        }

        if (data[1]?.data?.length > 0) {

            for (const siteItem of data[1]?.data[0]?.legalentity?.hassite) {

                sites.set(siteItem.site.nodeid, siteItem.site);
                if (siteItem.site.hasarea != undefined) {
                    for (const areaItem of siteItem.site.hasarea) {

                        areas.set(areaItem.area.nodeid, areaItem.area);
                        if (areaItem.area.hasequipment != undefined) {
                            for (const equipmentItem of areaItem.area.hasequipment) {

                                equipments.set(

                                    equipmentItem.equipment.nodeid,

                                    equipmentItem.equipment

                                );

                            }
                        }


                    }
                }


            }

        }
    }
    const handleClick = (event) => {
        setanchorEl(event.currentTarget)
        setopen(true)
    };

    const handleClose = () => {
        setanchorEl(null)
        setopen(false)
    };
 */

  useEffect(() => {
    props.setDashboardLoader({ state: true });
    setpoolsToDisplay([]);
    setmachinesToDisplay([]);
    setStorungCounter(0);
    setAuffCounter(0);
    setNotizCounter(0);
    setWartungenCounter(0);
    props.getallsitesareaeqs("", "ALL_SAE");
  }, []);

  // useEffect(() => {
  //   if (Object.keys(props.subscribedEquipments).length) {
  //     let nodeIds = [];
  //     for (const [key, value] of Object.entries(props.subscribedEquipments)) {
  //       nodeIds.push(value.nodeid);
  //     }
  //     if (nodeIds.length) {
  //     //   props.getall({equipmentnodeids:nodeIds,lang:"de",status:"2"}, "ALLNOTIFICATIONS");
  //     }
  //   }
  // }, [props.subscribedEquipments]);

  const handleStorungCrossClick = (value) => {
    setstorungCross(value);
  };
  const handleAuffCrossClick = (value) => {
    setauffCross(value);
  };
  /* const handleNotizCrossClick = (value) => {
        setnotizCross(value)
    } */
  const handleWartungenCrossClick = (value) => {
    setwartungenCross(value);
  };

  const AdjustPoolsFromType = () => {
    let FilteredObject = [];

    const tempArrayNoti = [];

    if (ApplyAreasFilter) {
      Object.keys(effectiveSubscribedSites).map((key) => {
        const Array = FilterValue.split("==>");

        effectiveSubscribedSites[key].hasarea &&
          effectiveSubscribedSites[key].hasarea.map((a, k) => {
            if (a.area.nodeid === selectedAreaNodeId) {
              const tempEp = [];
              a.area?.hasequipment?.length &&
                a.area.hasequipment.map((e, k) => {
                  if (
                    storungCross == false &&
                    auffCross == false &&
                    notizCross == false &&
                    wartungenCross == false
                  ) {
                    tempEp.push(e);
                  } else {
                    const filtered_notification =
                      e.equipment.hasnotification &&
                      e.equipment.hasnotification.filter(selectNotification);
                    if (
                      filtered_notification &&
                      filtered_notification.length > 0
                    ) {
                      tempEp.push(e);
                    }
                  }
                }); //equipments loop ends here

              if (tempEp.length) {
                FilteredObject.push({
                  equipmentpool: {
                    nodeid: a.area.nodeid,
                    name: a.area.name,
                    hasequipment: tempEp,
                  },
                });
              }
            } else if (selectedAreaNodeId === undefined) {
              const tempEp = [];
              a.area.hasequipment?.length &&
                a.area.hasequipment.map((e, k) => {
                  if (
                    storungCross == false &&
                    auffCross == false &&
                    notizCross == false &&
                    wartungenCross == false
                  ) {
                    tempEp.push(e);
                  } else {
                    const filtered_notification =
                      e.equipment.hasnotification &&
                      e.equipment.hasnotification.filter(selectNotification);
                    if (
                      filtered_notification &&
                      filtered_notification.length > 0
                    ) {
                      tempEp.push(e);
                    }
                  }
                }); //equipments loop ends here

              if (tempEp.length) {
                key === Array[1] &&
                  FilteredObject.push({
                    equipmentpool: {
                      nodeid: a.area.nodeid,
                      name: a.area.name,
                      hasequipment: tempEp,
                    },
                  });
              }
            }
          }); //area loop ends here
      });
    } else if (ApplyPoolsFilter) {
      if (Object.keys(effectiveSubscribedEquipmentpools).length > 0) {
        Object.keys(effectiveSubscribedEquipmentpools).map((key) => {
          if (effectiveSubscribedEquipmentpools[key].nodeid === selectedPoolNodeId) {
            const tempEp = [];
            effectiveSubscribedEquipmentpools[key]?.hasequipment?.length &&
              effectiveSubscribedEquipmentpools[key].hasequipment.map((e, k) => {
                if (
                  storungCross == false &&
                  auffCross == false &&
                  notizCross == false &&
                  wartungenCross == false
                ) {
                  tempEp.push(e);
                } else {
                  const filtered_notification =
                    e.equipment.hasnotification &&
                    e.equipment.hasnotification.filter(selectNotification);
                  if (
                    filtered_notification &&
                    filtered_notification.length > 0
                  ) {
                    tempEp.push(e);
                  }
                }
              }); //equipments loop ends here

            if (tempEp.length) {
              FilteredObject.push({
                  equipmentpool: {
                  nodeid: effectiveSubscribedEquipmentpools[key].nodeid,
                  name: { de: effectiveSubscribedEquipmentpools[key].name },
                  hasequipment: tempEp,
                },
              });
            }
          } else if (selectedPoolNodeId === undefined) {
            const tempEp = [];
            effectiveSubscribedEquipmentpools[key].hasequipment?.length &&
              effectiveSubscribedEquipmentpools[key].hasequipment.map((e, k) => {
                if (
                  storungCross == false &&
                  auffCross == false &&
                  notizCross == false &&
                  wartungenCross == false
                ) {
                  tempEp.push(e);
                } else {
                  const filtered_notification =
                    e.equipment.hasnotification &&
                    e.equipment.hasnotification.filter(selectNotification);
                  if (
                    filtered_notification &&
                    filtered_notification.length > 0
                  ) {
                    tempEp.push(e);
                  }
                }
              }); //equipments loop ends here

            if (tempEp.length) {
              FilteredObject.push({
                equipmentpool: {
                  nodeid: effectiveSubscribedEquipmentpools[key].nodeid,
                  name: { de: effectiveSubscribedEquipmentpools[key].name },
                  hasequipment: tempEp,
                },
              });
            }
          }
        }); //equipmentpool loop end here
      }
    } else {
      // if no sites subs
      if (Object.keys(effectiveSubscribedSites).length > 0) {
        Object.keys(effectiveSubscribedSites).map((key) => {
          effectiveSubscribedSites[key].hasarea.map((a, k) => {
            const tempEp = [];
            a.area.hasequipment?.length &&
              a.area.hasequipment.map((e, k) => {
                if (
                  storungCross == false &&
                  auffCross == false &&
                  notizCross == false &&
                  wartungenCross == false
                ) {
                  tempEp.push(e);
                } else {
                  const filtered_notification =
                    e.equipment.hasnotification &&
                    e.equipment.hasnotification.filter(selectNotification);
                  if (
                    filtered_notification &&
                    filtered_notification.length > 0
                  ) {
                    tempEp.push(e);
                  }
                }
              }); //equipments loop ends here

            if (tempEp.length) {
              FilteredObject.push({
                equipmentpool: {
                  nodeid: a.area.nodeid,
                  name: a.area.name,
                  hasequipment: tempEp,
                },
              });
            }
          }); //area loop ends here
        });
      } else {
        if (Object.keys(effectiveSubscribedEquipmentpools).length > 0) {
          Object.keys(effectiveSubscribedEquipmentpools).map((key) => {
            const tempEp = [];
            effectiveSubscribedEquipmentpools[key]?.hasequipment?.length &&
              effectiveSubscribedEquipmentpools[key].hasequipment.map((e, k) => {
                if (
                  storungCross == false &&
                  auffCross == false &&
                  notizCross == false &&
                  wartungenCross == false
                ) {
                  tempEp.push(e);
                } else {
                  const filtered_notification =
                    e.equipment.hasnotification &&
                    e.equipment.hasnotification.filter(selectNotification);
                  if (
                    filtered_notification &&
                    filtered_notification.length > 0
                  ) {
                    tempEp.push(e);
                  }
                }
              }); //equipments loop ends here

            if (tempEp.length) {
              FilteredObject.push({
                equipmentpool: {
                  nodeid: effectiveSubscribedEquipmentpools[key].nodeid,
                  name: { de: effectiveSubscribedEquipmentpools[key].name },
                  hasequipment: tempEp,
                },
              });
            }
          }); //equipmentpool loop end here
        }
      }
    }
    return FilteredObject;
  };

  const selectNotification = (n) => {
    if (
      storungCross == false &&
      auffCross == false &&
      notizCross == false &&
      wartungenCross == false
    ) {
      return true;
    }

    if (storungCross) {
      if (storungTypes.includes(n.notification.type)) {
        return true;
      }
    }

    if (auffCross) {
      if (n.notification.type == 1) {
        return true;
      }
    }

    if (notizCross) {
      if (n.notification.type == 2) {
        return true;
      }
    }

    if (wartungenCross) {
      if (n.notification.type == 6) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    if (!Object.keys(effectiveSubscribedSites).length || hasAppliedDefaultSite.current) {
      return;
    }

    const siteValues = Object.values(effectiveSubscribedSites);
    const preferredSite =
      siteValues.find((site) => site.nodeid === DEFAULT_FETTE_SITE_NODEID) ||
      siteValues.find((site) =>
        site?.name?.toLowerCase?.().includes("fette")
      ) ||
      siteValues[0];

    if (preferredSite?.nodeid) {
      hasAppliedDefaultSite.current = true;
      setFilterValue("s==>" + preferredSite.nodeid);
    }
  }, [effectiveSubscribedSites]);

  const handlechange = (e) => {
    setstorungCross(false);
    setauffCross(false);
    setwartungenCross(false);

    setFilterValue(e.target.value);
    window.blurAll();
  };

  const ExtractPoolsFromSAE = (Array) => {
    setTitle("Equipment Pools");
    setApplyPoolsFilter(true);
    setApplyAreasFilter(false);
    if (Array[1] == "0") {
      const filtered_pool = effectiveSubscribedEquipmentpools;
      adjustCountersForPool(filtered_pool);
      const FilteredObject = [];
      Object.keys(effectiveSubscribedEquipmentpools).map((key) => {
        if (effectiveSubscribedEquipmentpools[key].hasequipment) {
          FilteredObject.push({
            equipmentpool: {
              nodeid: effectiveSubscribedEquipmentpools[key].nodeid,
              name: { de: effectiveSubscribedEquipmentpools[key].name },
              hasequipment: effectiveSubscribedEquipmentpools[key].hasequipment,
            },
          });
        }
      });
      return FilteredObject;
    } else {
      const filtered_machines =
        effectiveSubscribedEquipmentpools[Array[1]]?.hasequipment;
      const FilteredObject = [];
      if (filtered_machines) {
        FilteredObject.push({
          equipmentpool: {
            nodeid: effectiveSubscribedEquipmentpools[Array[1]].nodeid,
            name: { de: effectiveSubscribedEquipmentpools[Array[1]].name },
            hasequipment: filtered_machines,
          },
        });
      }
      adjustCountersForPool(effectiveSubscribedEquipmentpools[Array[1]]);

      return FilteredObject;
    }
  };

  const ExtractAllAreasMachinesFromSAE = (Array) => {
    const FilteredObject = [];
    setApplyPoolsFilter(false);
    setApplyAreasFilter(true);

    for (const site of Object.keys(effectiveSubscribedSites)) {
      if (effectiveSubscribedSites[site].nodeid == Array[1]) {
        setTitle(effectiveSubscribedSites[site].name);
        if (effectiveSubscribedSites[site]?.hasarea?.length) {
          for (const area of effectiveSubscribedSites[site].hasarea) {
            if (area.area.hasequipment && area.area.hasequipment.length) {
              FilteredObject.push({
                equipmentpool: {
                  nodeid: area.area.nodeid,
                  name: { de: area.area.name },
                  hasequipment: area.area.hasequipment,
                },
              });
            }
          }
        }
      }
    }
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
  };

  const ExtractMachinesofAreaFromSAE = (Array) => {
    const FilteredObject = [];
    setApplyPoolsFilter(false);
    setApplyAreasFilter(true);
    for (const site of Object.keys(effectiveSubscribedSites)) {
      if (effectiveSubscribedSites[site].hasarea) {
        for (const area of effectiveSubscribedSites[site].hasarea) {
          if (area.area.nodeid == Array[1]) {
            setTitle(effectiveSubscribedSites[site].name);
            const filtered_machines = area.area.hasequipment;
            if (filtered_machines) {
              FilteredObject.push({
                equipmentpool: {
                  nodeid: area.area.nodeid,
                  name: { de: area.area.name },
                  hasequipment: area.area.hasequipment,
                },
              });
            }
          }
        }
      }
    }
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
  };

  const handleTimeChange = (e) => {
    setstorungCross(false);
    setauffCross(false);
    setwartungenCross(false);

    setFilterTimerange(e.target.value);
  };

  const SwitchTimeFilter = (x, pools) => {
    let final_pools = [];

    if (
      pools &&
      pools.length > 0 &&
      pools[0]?.equipmentpool?.hasequipment.length > 0
    ) {
      if (x == "all") {
        if (ApplyAreasFilter) {
          final_pools = ApplyTimeFilterAll(pools);
        } else if (ApplyPoolsFilter) {
          final_pools = ApplyTimeFilterAll(pools);
        }
      } else if (x == "today") {
        if (ApplyAreasFilter) {
          final_pools = ApplyTimeFilterToday(pools);
        } else if (ApplyPoolsFilter) {
          final_pools = ApplyTimeFilterToday(pools);
        }
      } else if (x == "week") {
        if (ApplyAreasFilter) {
          final_pools = ApplyTimeFilterWeek(pools);
        } else if (ApplyPoolsFilter) {
          final_pools = ApplyTimeFilterWeek(pools);
        }
      } else if (x == "month") {
        if (ApplyAreasFilter) {
          final_pools = ApplyTimeFilterMonthly(pools);
        } else if (ApplyPoolsFilter) {
          final_pools = ApplyTimeFilterMonthly(pools);
        }
      }
    } else {
      final_pools = pools;
    }

    return final_pools;
  };

  const ApplyTimeFilterAll = (array) => {
    const FilteredObject = [];
    let FilteredMachines = [];
    array.map((x, k) => {
      x.equipmentpool?.hasequipment?.length &&
        x.equipmentpool.hasequipment.map((y, k) => {
          FilteredMachines.push(y);
        });

      if (FilteredMachines.length) {
        FilteredObject.push({
          equipmentpool: {
            nodeid: x.equipmentpool.nodeid,
            name: x.equipmentpool.name,
            hasequipment: FilteredMachines,
          },
        });
      }
      FilteredMachines = [];
    });
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
  };
  const ApplyTimeFilterToday = (array) => {
    var todayTS = moment()
      .startOf("day")
      .valueOf();
    const FilteredObject = [];
    let FilteredMachines = [];
    array.map((x, k) => {
      x.equipmentpool?.hasequipment?.length &&
        x.equipmentpool.hasequipment.map((y, k) => {
          const TodayNotificationsMachines =
            y.equipment.hasnotification != undefined
              ? y.equipment.hasnotification.filter(
                  (n) => n.notification.created > todayTS
                )
              : [];
          if (TodayNotificationsMachines.length > 0) {
            FilteredMachines.push(y);
          }
        });
      if (FilteredMachines.length) {
        FilteredObject.push({
          equipmentpool: {
            nodeid: x.equipmentpool.nodeid,
            name: x.equipmentpool.name,
            hasequipment: FilteredMachines,
          },
        });
      }
      FilteredMachines = [];
    });
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
  };

  const ApplyTimeFilterWeek = (array) => {
    var today = new Date();
    var lastweek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    var lastweekTS = lastweek.getTime();
    const FilteredObject = [];
    let FilteredMachines = [];
    array.map((x, k) => {
      x.equipmentpool?.hasequipment?.length &&
        x.equipmentpool.hasequipment.map((y, k) => {
          const weeklyNotificationsMachines =
            y.equipment.hasnotification != undefined
              ? y.equipment.hasnotification.filter(
                  (n) => n.notification.created > lastweekTS
                )
              : [];
          if (weeklyNotificationsMachines.length > 0) {
            FilteredMachines.push(y);
          }
        });
      if (FilteredMachines.length) {
        FilteredObject.push({
          equipmentpool: {
            nodeid: x.equipmentpool.nodeid,
            name: x.equipmentpool.name,
            hasequipment: FilteredMachines,
          },
        });
      }
      FilteredMachines = [];
    });
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
    // setpoolsToDisplay(FilteredObject)
  };

  const ApplyTimeFilterMonthly = (array) => {
    var today = new Date();
    var lastmonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate()
    );
    var lastmonthTS = lastmonth.getTime();
    const FilteredObject = [];
    let FilteredMachines = [];
    array.map((x, k) => {
      x.equipmentpool?.hasequipment?.length &&
        x.equipmentpool.hasequipment.map((y, k) => {
          const MonthlyNotificationsMachines =
            y.equipment.hasnotification != undefined
              ? y.equipment.hasnotification.filter(
                  (n) => n.notification.created > lastmonthTS
                )
              : [];
          if (MonthlyNotificationsMachines.length > 0) {
            FilteredMachines.push(y);
          }
        });
      if (FilteredMachines.length) {
        FilteredObject.push({
          equipmentpool: {
            nodeid: x.equipmentpool.nodeid,
            name: x.equipmentpool.name,
            hasequipment: FilteredMachines,
          },
        });
      }
      FilteredMachines = [];
    });
    adjustCountersForArea(FilteredObject);
    return FilteredObject;
    // setpoolsToDisplay(FilteredObject)
  };

  const adjustCountersForPool = (p) => {
    let tempArrayNoti = [];
    if (p.nodeid != undefined) {
      p.hasequipment?.length &&
        p.hasequipment.map((e, k) => {
          e.equipment.hasnotification &&
            e.equipment.hasnotification.map((n, k) => {
              tempArrayNoti.push(n);
            });
        });
    } else {
      Object.keys(p).map((key) => {
        /*  if(p[key].nodeid===selectedPoolNodeId){ */
        p[key]?.hasequipment?.length &&
          p[key].hasequipment.map((e, k) => {
            e.equipment.hasnotification &&
              e.equipment.hasnotification.map((n, k) => {
                tempArrayNoti.push(n);
              });
          });
        /*  } */
      });
    }

    setStorungCounter(
      tempArrayNoti.filter((n) => storungTypes.includes(n.notification.type))
        .length > 0
        ? tempArrayNoti.filter((n) =>
            storungTypes.includes(n.notification.type)
          ).length
        : 0
    );
    setAuffCounter(
      tempArrayNoti.filter((n) => n.notification.type == 1).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 1).length
        : 0
    );
    setNotizCounter(
      tempArrayNoti.filter((n) => n.notification.type == 2).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 2).length
        : 0
    );
    setWartungenCounter(
      tempArrayNoti.filter((n) => n.notification.type == 6).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 6).length
        : 0
    );
  };

  const adjustCountersForArea = (p) => {
    let tempArrayNoti = [];
    p &&
      p.map((ep, k) => {
        ep &&
          ep?.equipmentpool?.hasequipment?.length &&
          ep.equipmentpool.hasequipment.map((e, k) => {
            e &&
              e.equipment.hasnotification &&
              e.equipment.hasnotification.map((n, k) => {
                tempArrayNoti.push(n);
              });
          });
      });

    setStorungCounter(
      tempArrayNoti.filter((n) => storungTypes.includes(n.notification.type))
        .length > 0
        ? tempArrayNoti.filter((n) =>
            storungTypes.includes(n.notification.type)
          ).length
        : 0
    );
    setAuffCounter(
      tempArrayNoti.filter((n) => n.notification.type == 1).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 1).length
        : 0
    );
    setNotizCounter(
      tempArrayNoti.filter((n) => n.notification.type == 2).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 2).length
        : 0
    );
    setWartungenCounter(
      tempArrayNoti.filter((n) => n.notification.type == 6).length > 0
        ? tempArrayNoti.filter((n) => n.notification.type == 6).length
        : 0
    );
  };

  /* const handleDropDown = (event) => {
        if (event.target.value === 1 || 2)
            setDisplayL2(true)
        else if (event.target.value === 0)
            setDisplayL2(false)
    } */

  /*  useEffect(() => {
         getenterpriseswithtypes()
         getall('', 'ALLNOTIFICATIONS')
         processLoadSitesData(props.saeData)
     }, [props.saeData]) */

  socket.on("server:notification:created", (payload) => {
    let filtered_machine = [];
    effectiveSubscribedEquipmentpools &&
      Object.keys(effectiveSubscribedEquipmentpools).map((key) => {
        effectiveSubscribedEquipmentpools[key].hasequipment?.length &&
          effectiveSubscribedEquipmentpools[key].hasequipment.map((e, k) => {
            if (e.equipment.nodeid == payload.notification.equipmentnodeid) {
              filtered_machine.push(e);
            }
          });
      });

    if (filtered_machine.length > 0) {
      if (storungTypes.includes(payload.notification.type)) {
        setStorungCounter(StorungCounter + 1);
        setStorungUnReadCounter(StorungUnReadCounter + 1);
      } else if (payload.notification.type == 1) {
        setAuffCounter(AuffCounter + 1);
        setAuffUnReadCounter(AuffUnReadCounter + 1);
      } else if (payload.notification.type == 2) {
        setNotizCounter(NotizCounter + 1);
        setNotizUnReadCounter(NotizUnReadCounter + 1);
      } else if (payload.notification.type == 6) {
        setWartungenCounter(WartungenCounter + 1);
        setWartungenUnReadCounter(WartungenUnReadCounter + 1);
      }
    }
  });

  socket.on("server:eqNotification:created", (payload) => {
    props.getKpisData(
      { equipmentnodeids: [payload.equipmentnodeid] },
      "GETKPISDATA"
    );
  });

  useEffect(() => {
    let pools = [];
    setpoolsToDisplay([]);
    if ((ApplyAreasFilter || ApplyPoolsFilter) && FilterValue !== undefined) {
      const Array = FilterValue.split("==>");
      if (Array[0] == "p") {
        pools = ExtractPoolsFromSAE(Array);
        if (Array[1] !== "0") {
          setSelectedPoolNodeId(Array[1]);
        } else {
          setSelectedPoolNodeId();
        }
      } else if (Array[0] == "s") {
        pools = ExtractAllAreasMachinesFromSAE(Array);
        setSelectedSiteNodeId(Array[1]);
        setSelectedAreaNodeId();
      } else if (Array[0] == "a") {
        pools = ExtractMachinesofAreaFromSAE(Array);
        if (Array[1] !== "0") {
          setSelectedAreaNodeId(Array[1]);
        }
      }
    }
    if (storungCross || auffCross || notizCross || wartungenCross) {
      pools = AdjustPoolsFromType();
    }

    if (FilterTimerange !== undefined) {
      pools = SwitchTimeFilter(FilterTimerange, pools);
    }


    setpoolsToDisplay(pools);
    aggregateKPIs(props.kpis.kpis, pools);
  }, [
    storungCross,
    auffCross,
    notizCross,
    wartungenCross,
    FilterValue,
    FilterTimerange,
    effectiveSubscribedSites,
  ]);
  const [existingKPIs, setExistingKPIs] = useState();
  useEffect(() => {
    if (props.kpis.kpis && props.kpis.kpis.length > 0) {
      aggregateKPIs(props.kpis.kpis, poolsToDisplay);
    }
  }, [props.kpis]);

  function aggregateKPIs(kpisData, equipmentPools) {
    // Convert existing KPI data into a map for quick lookup
    const kpiMap = new Map();
    if (existingKPIs !== undefined && existingKPIs.size !== 0) {
    // Add existing KPIs to the map
    existingKPIs.forEach((value, key) => {
      kpiMap.set(key,value);
    });
   }
    // Add new kpisData to the map
    if (kpisData !== undefined) {
      kpisData.forEach(({ equipment }) => {
        kpiMap.set(
          equipment.nodeid,
          equipment.kpis.reduce((acc, kpi) => {
            acc[kpi.name] = kpi.value || 0; // Handle null values
            return acc;
          }, {})
        );
      });
    }
  
    // Process each equipment pool to aggregate KPIs
    const aggregatedData = equipmentPools.map(({ equipmentpool }) => {
      let totalMtbf = 0;
      let totalCompMtNoti = 0;
      let totalTotalMtNoti = 0;
      let totalTotalStorung = 0;
      let count = 0;
  
      equipmentpool.hasequipment.forEach(({ equipment }) => {
        const kpi = kpiMap.get(equipment.nodeid);
        if (kpi) {
          if(kpi.mtbf > 0) {
          totalMtbf += kpi.mtbf;
          count++;
          }
          totalCompMtNoti += kpi.compMtNoti;
          totalTotalMtNoti += kpi.totalMtNoti;
          totalTotalStorung += kpi.totalStorung;
        
        }
      });
  
      return {
        areaNodeId: equipmentpool.nodeid,
        areaName: equipmentpool.name.de,
        kpis: {
          mtbf: count > 0 ? totalMtbf / count : 0, // Average
          compMtNoti: totalCompMtNoti, // Sum
          totalMtNoti: totalTotalMtNoti, // Sum
          totalStorung: totalTotalStorung, // Sum
        },
      };
    });
  
    // Optionally, update local state if necessary
    setExistingKPIs(kpiMap);
    setLocalKpis(aggregatedData); // Assuming setLocalKpis updates your state
    return aggregatedData;
  }
  

  useEffect(() => {
    if (props.updateProfile === true) {
      props.getsitesareaeqs2("", "SAE2");
    }
  }, [props.updateProfile]);

  let _sites = Object.keys(effectiveSubscribedSites).length > 0;
  let _areas = Object.keys(effectiveSubscribedAreas).length > 0;
  let _pools = Object.keys(effectiveSubscribedEquipmentpools).length > 0;
  let _machines = Object.keys(effectiveSubscribedEquipments).length > 0;

  useEffect(() => {
    if (!_sites) {
      setFilterValue("p==>0");
    }
  }, [effectiveSubscribedSites]);

  useEffect(() => {
    let eqs = [];

    if (props.allsitesareaseqs.length) {
      props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
        (siteItem, key) => {
          return (
            siteItem.site?.hasarea &&
            siteItem.site.hasarea.map((areaItem) => {
              if (areaItem.area?.hasequipment?.length) {
                eqs.push("true");
              }
            })
          );
        }
      );

      props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool?.map(
        (poolItem, key) => {
          if (poolItem.equipmentpool?.hasequipment?.length) {
            eqs.push("true");
          }
        }
      );
    }

    setHas_Equipment(eqs);
  }, [props.allsitesareaseqs]);

  // const pleaseDelete = () => {
  //   props.DeleteMaintenanceTask({ maintenancetasknodeid:"247fn://247uptime.io/33ad44c0-6a60-4580-a254-fb328cc4936b", equipmentnodeid:"247fn://247uptime.io/5b3c3138-4dc1-44d9-b994-b702b1839283" });
  // }

  return (
    <section
      className="newDashboardSection"
      style={{ marginBottom: "20%" }}
      id="tab_dashboard_main"
      data-testid="tab_dashboard_main"
    >
      {/* <Button onClick={pleaseDelete}>Please delete</Button> */}

      {!has_equipment.includes("true") && props.dashboardLoader === false ? (
        <InitialState
          disableEquipmentButton={
            Object.keys(effectiveSubscribedAreas).length === 0 &&
            Object.keys(effectiveSubscribedEquipmentpools).length === 0
          }
        />
      ) : (
        // <LazyLoad once>
          <Paper
            elevation={props.zeroPadding ? 0 : Theme247.elevationLow}
            className={classes.elevatedSection}
            style={{
              padding: props.zeroPadding ? 0 : undefined,
              boxShadow: props.zeroPadding ? "none" : undefined,
            }}
          >
            {props.isAuthUser ? (
              <>
                <header className={classes.sectionHeader}>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography variant="h1">{Title}</Typography>
                        {props.headerAction ? props.headerAction : null}
                      </div>
                    </Grid>

                    <Grid item>
                      <FormControl
                        variant="standard"
                        className={classes.filterStyle}
                      >
                        <>
                          <div
                            style={{
                              display: displayL2 === true ? "block" : "none",
                            }}
                          >
                            <InputLabel
                              htmlFor="grouped-native-select"
                              style={{
                                color: "#9E9E9E",
                                display: "block",
                                fontSize: "12px",
                                lineHeight: 1,
                                marginBottom: "8px",
                              }}
                            >
                              {i18n.machinepark}/{i18n.area_label}
                            </InputLabel>
                            <Select
                              defaultValue={"Alle Bereiche"}
                              native
                              className="grouped-native-select"
                              onChange={handlechange}
                              value={FilterValue}
                            >
                              {effectiveSubscribedSites &&
                                Object.keys(effectiveSubscribedSites).map((key) => {
                                  return (
                                    <optgroup
                                      defaultValue={"Alle Bereiche"}
                                      key={key}
                                      label={effectiveSubscribedSites[key].name}
                                    >
                                      <option
                                        key={key}
                                        value={
                                          "s==>" + effectiveSubscribedSites[key].nodeid
                                        }
                                      >
                                        {"Alle Areas"}
                                      </option>
                                      {effectiveSubscribedSites[key].hasarea &&
                                        effectiveSubscribedSites[key].hasarea.length &&
                                        effectiveSubscribedSites[key].hasarea.map(
                                          (y, k) => {
                                            return (
                                              <option
                                                key={k}
                                                value={"a==>" + y.area.nodeid}
                                              >
                                                {y.area.name}
                                              </option>
                                            );
                                          }
                                        )}
                                    </optgroup>
                                  );
                                })}
                              <optgroup
                                defaultValue={"p==>0"}
                                label={"Equipment Pools"}
                              >
                                <option value={"p==>0"}>
                                  {"Alle Equipment Pools"}
                                </option>
                                {effectiveSubscribedEquipmentpools &&
                                  Object.keys(effectiveSubscribedEquipmentpools).map(
                                    (key) => {
                                      return (
                                        <option
                                          key={key}
                                          value={
                                            "p==>" +
                                            effectiveSubscribedEquipmentpools[key].nodeid
                                          }
                                        >
                                          {effectiveSubscribedEquipmentpools[key].name}
                                        </option>
                                      );
                                    }
                                  )}
                              </optgroup>
                            </Select>
                          </div>
                        </>
                      </FormControl>

                      <em style={{ paddingLeft: 50 }}></em>

                      <FormControl
                        variant="standard"
                        className={classes.filterStyle}
                      >
                        <InputLabel
                          id="label-timerange"
                          style={{
                            color: "#9E9E9E",
                            display: "block",
                            fontSize: "12px",
                            lineHeight: 1,
                            marginBottom: "8px",
                          }}
                          // className={_s(Theme247.formControlLabel)}
                        >
                          {i18n.timerange}
                        </InputLabel>
                        <Select
                          variant="standard"
                          labelId="label-timerange"
                          value={FilterTimerange}
                          onChange={handleTimeChange}
                          id="grouped-native-select"
                          defaultValue={"FilterTimerange"}
                          placeholder={i18n.no_time_range_selected}
                        >
                          {filterTimerangeValues.map((range) => {
                            return (
                              <MenuItem key={range.value} value={range.value}>
                                {range.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </header>

                <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Grid item xs={12}>
                    <div
                      className="flexDiv"
                      style={{ justifyContent: "flex-start" }}
                    >
                      {StorungCounter > 0 && poolsToDisplay.length > 0 && (
                        <div className="noti">
                          {" "}
                          <NotificationCardItem
                            bgColor={getNotificationTooltipAndColor(0)?.color}
                            type={12}
                            StorungCrossClick={handleStorungCrossClick}
                            storungCross={storungCross}
                            storungCount={StorungCounter}
                            StorungUnReadCounter={StorungUnReadCounter}
                          />
                        </div>
                      )}
                      {AuffCounter > 0 && poolsToDisplay.length > 0 && (
                        <div className="noti">
                          {" "}
                          <NotificationCardItem
                            bgColor={getNotificationTooltipAndColor(1)?.color}
                            type={1}
                            AuffCrossClick={handleAuffCrossClick}
                            auffCross={auffCross}
                            AuffCounter={AuffCounter}
                            AuffUnReadCounter={AuffUnReadCounter}
                          />
                        </div>
                      )}
                      {WartungenCounter > 0 && poolsToDisplay.length > 0 && (
                        <div className="noti" style={{ marginRight: 0 }}>
                          {" "}
                          <NotificationCardItem
                            bgColor={getNotificationTooltipAndColor(6)?.color}
                            type={6}
                            WartungenCrossClick={handleWartungenCrossClick}
                            wartungenCross={wartungenCross}
                            WartungenCounter={WartungenCounter}
                            WartungenUnReadCounter={WartungenUnReadCounter}
                          />
                        </div>
                      )}
                    </div>
                  </Grid>
                </Grid>

                <div className={classes.itemcardGrid}>
                  {props.dashboardLoader && poolsToDisplay.length === 0 ? (
                    <Stack spacing={1}>
                      <Skeleton
                        animation="wave"
                        width={200}
                        variant="text"
                        sx={{ fontSize: "1rem" }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "23px",
                        }}
                      >
                        <Skeleton
                          variant="rounded"
                          width={425}
                          height={97}
                          animation="wave"
                        />
                        <Skeleton
                          variant="rounded"
                          width={425}
                          height={97}
                          animation="wave"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "23px",
                        }}
                      >
                        <Skeleton
                          variant="rounded"
                          width={425}
                          height={97}
                          animation="wave"
                        />
                        <Skeleton
                          variant="rounded"
                          width={425}
                          height={97}
                          animation="wave"
                        />
                      </div>
                    </Stack>
                  ) : props.dashboardLoader === false &&
                    (poolsToDisplay.length === 0 ||
                      poolsToDisplay[0]?.equipmentpool?.hasequipment?.length ===
                        0) ? (
                      <EmptyState
                      heading={""}
                      title={
                        !FilterTimerange.includes("all")
                          ? i18n.dashboard_empty_open_notifications
                          : FilterValue.split("==>")[1]?.length > 1
                          ? ""
                          : i18n.dashboard_empty_welcome.replace("%s", isFette ? "Fette Compecting" : "247Access")
                      }
                      description={""}
                      icon={""}
                      hasButton
                      button={
                        !(FilterValue.split("==>")[1]?.length > 1) &&
                        FilterTimerange.includes("all") ? (
                          <div style={{ marginTop: "20px" }}>
                            <Button
                              onClick={() => {
                                navigate(prefixPath("/profile"));
                              }}
                              variant="contained"
                              color="primary"
                            >
                              {i18n.empty_dashboard_button}
                            </Button>
                          </div>
                        ) : (
                          ""
                        )
                      }
                    />
                  ) : poolsToDisplay &&
                    poolsToDisplay.length > 0 &&
                    poolsToDisplay[0].equipmentpool === undefined ? (
                    //areas rendering initially
                    poolsToDisplay.map((x, key) => {
                      return (
                        <div key={key} className={classes.itemcardGridSection}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "16px",
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              variant="h2"
                              className={classes.itemcardGridHeadline}
                            >
                              {getLocalizedNameValue(x?.area?.name, language)}
                            </Typography>
                            {renderSectionAction({
                              type: "area",
                              nodeid: x?.area?.nodeid,
                              name: getLocalizedNameValue(
                                x?.area?.name,
                                language
                              ),
                            })}
                          </div>
                          {x?.area?.hasequipment &&
                            x?.area?.hasequipment?.map((y, key) => {
                              // console.log("Y machines .... ",y.equipment)
                              var image_url = "";

                              return (
                                <div
                                  key={key}
                                  className={classes.itemcardGridItem}
                                >
                                  <Link
                                    to={prefixPath("/machine-overview")}
                                    query={{ nodeid: y?.equipment?.nodeid }}
                                    state={{
                                      nodeid: y?.equipment?.nodeid,
                                      area: x,
                                      poolnodeid: x?.area?.nodeid,
                                      from: "area",
                                      customernodeid: props.customerNodeId,
                                    }}
                                  >
                                    <SafeMachineCardItem
                                      borderColor={hasMalfunction(
                                        y?.equipment?.hasnotification
                                      )}
                                      title={truncateWithEllipses(
                                        getLocalizedNameValue(
                                          y?.equipment?.name,
                                          language
                                        ),
                                        40
                                      )}
                                      description={` ${
                                        y?.equipment?.hasequipmenttype[0]
                                          ?.equipmenttype?.isequipmenttypeof !==
                                        undefined
                                          ? y?.equipment?.hasequipmenttype[0]
                                              ?.equipmenttype
                                              ?.isequipmenttypeof[0]?.brand
                                              ?.name
                                          : ""
                                      } ${
                                        y?.equipment?.hasequipmenttype[0]
                                          ?.equipmenttype?.model
                                      }`}
                                      imageSrc={
                                        getEquipmentCardImageSrc(y?.equipment)
                                      }
                         
                                      iconText={
                                        y?.equipment?.equipmentid
                                          ? "Eq.-Nr " +
                                            y?.equipment?.equipmentid
                                          : ""
                                      }
                                      className=""
                                    />
                                  </Link>
                                </div>
                              );
                            })}
                        </div>
                      );
                    })
                  ) : (
                    poolsToDisplay &&
                    poolsToDisplay.length > 0 &&
                    poolsToDisplay.map((x, key) => {
                      return (
                        <div key={key} className={classes.itemcardGridSection}>
                          {x?.equipmentpool?.hasequipment.length ? (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "16px",
                                  flexWrap: "nowrap",
                                  marginBottom: "12px",
                                }}
                              >
                                <Typography
                                  variant="h2"
                                  className={classes.itemcardGridHeadline}
                                  style={{
                                    marginBottom: 0,
                                    width: "auto",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    flex: "0 1 auto",
                                  }}
                                >
                                  {getLocalizedNameValue(
                                    x?.equipmentpool?.name,
                                    language
                                  )}{" "}
                                  {/* <Link
                                  to={
                                    "/create-area?nodeid=" +
                                    x?.equipmentpool?.nodeid
                                  }
                                  state={{
                                    nodeid: x?.equipmentpool?.nodeid,
                                    name: x?.equipmentpool?.name,
                                    areaid: x?.equipmentpool?.areaid,
                                    pageType: "edit",
                                    sitename: Title,
                                  }}
                                >
                                  {" "}
                                  <ModeEditOutlinedIcon />{" "}
                                </Link>{" "} */}
                                </Typography>
                                {renderSectionAction({
                                  type: "pool",
                                  nodeid: x?.equipmentpool?.nodeid,
                                  name: getLocalizedNameValue(
                                    x?.equipmentpool?.name,
                                    language
                                  ),
                                })}
                              </div>
                              <div className="KPI_Card_Wrapper">
                                  {localKpis &&
                                    localKpis.map((kpiObject, index) => {
                                      return (
                                        <>
                                          {x?.equipmentpool.nodeid ===
                                          kpiObject.areaNodeId ? (
                                            <>
                                              <div className="KPI_Card bxShadow">
                                                <div className="numeric">
                                                  {" "}
                                                  <div className="first">
                                                    {(""+kpiObject.kpis.mtbf.toFixed(2)).replace(".",",")}
                                                  </div>{" "}
                                                  <div
                                                    className="second"
                                                    style={{
                                                      marginLeft: kpiObject.kpis
                                                        .mtbf.length
                                                        ? "12px"
                                                        : "5.5px",
                                                    }}
                                                  >
                                                    h <Tooltip  title={<div> {i18n.dashboard_kpi_mtbf_tooltip} </div>}>
                                                    <span className="__tooliop"><Info fontSize={"small"}/></span>
                                                      </Tooltip>
                                                  </div>
                                                </div>
                                                <div className="_text">
                                                  {i18n.dashboard_kpi_mtbf}
                                                </div>
                                                <div className="description">
                                                  {i18n.dashboard_kpi_total_range}
                                                </div>
                                              </div>
                                              <div className="KPI_Card bxShadow">
                                                <div className="numeric">
                                                  {" "}
                                                  <div className="first">
                                                    {kpiObject.kpis.compMtNoti}
                                                  </div>{" "}
                                                  <div
                                                    className="second"
                                                    style={{
                                                      marginLeft: kpiObject.kpis
                                                        .totalMtNoti
                                                        ? "12px"
                                                        : "5.5px",
                                                    }}
                                                  >
                                                    /
                                                    {kpiObject.kpis.totalMtNoti}

                                                    <Tooltip title={<div> {i18n.dashboard_kpi_maintenance_done_tooltip} </div>}>
                                                    <span className="__tooliop"><Info fontSize={"small"}/></span>
                                                      </Tooltip>

                                                  </div>
                                                </div>
                                                <div className="_text">
                                                  {i18n.dashboard_kpi_maintenance_done}
                                                </div>
                                                <div className="description">
                                                {i18n.dashboard_kpi_last_12_months}
                                                </div>
                                              </div>
                                              <div className="KPI_Card bxShadow">
                                                <div className="numeric">
                                                  {" "}
                                                  <div className="first">
                                                    {
                                                      kpiObject.kpis
                                                        .totalStorung
                                                    }
                                                  </div>{" "}
                                                  <div
                                                    className="second"
                                                    style={{
                                                      marginLeft: ""
                                                        ? "12px"
                                                        : "5.5px",
                                                    }}
                                                  > 
                                                    <Tooltip title={<div> {i18n.dashboard_kpi_unplanned_downtimes_tooltip} </div>}>
                                                    <span className="__tooliop"><Info fontSize={"small"}/></span>
                                                      </Tooltip>
                                                      </div>
                                                </div>
                                                <div className="_text">
                                                  {i18n.dashboard_kpi_unplanned_downtimes}
                                                </div>
                                                <div className="description">
                                                {i18n.dashboard_kpi_last_12_months}
                                                </div>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      );
                                    })}
                                </div>

                              {/* KPI Stuff */}

                              {x?.equipmentpool?.hasequipment &&
                                x?.equipmentpool?.hasequipment.map((y, key) => {
                                  //  console.log("Y machines .... ",y.equipment)
                                  var image_url = "";

                                  return (
                                    <div
                                      key={key}
                                      className={classes.itemcardGridItem}
                                    >
                                      <Link
                                        to={prefixPath("/machine-overview")}
                                        query={{ nodeid: y?.equipment?.nodeid }}
                                        state={{
                                          nodeid: y?.equipment?.nodeid,
                                          pool: x.equipmentpool,
                                          poolnodeid: x?.equipmentpool?.nodeid,
                                          from: "pool",
                                          customernodeid: props.customerNodeId,
                                        }}
                                      >
                                        <SafeMachineCardItem
                                          borderColor={hasMalfunction(
                                            y?.equipment?.hasnotification
                                          )}
                                          title={truncateWithEllipses(
                                            getLocalizedNameValue(
                                              y?.equipment?.name,
                                              language
                                            ),
                                            40
                                          )}
                                          description={` ${
                                            y?.equipment?.hasequipmenttype
                                              ? y?.equipment
                                                  ?.hasequipmenttype[0]
                                                  ?.equipmenttype
                                                  ?.isequipmenttypeof !==
                                                undefined
                                                ? y?.equipment
                                                    ?.hasequipmenttype[0]
                                                    ?.equipmenttype
                                                    ?.isequipmenttypeof[0].brand
                                                    ?.name
                                                : ""
                                              : ""
                                          } ${
                                            y?.equipment?.hasequipmenttype
                                              ? y?.equipment
                                                  ?.hasequipmenttype[0]
                                                  ?.equipmenttype?.model
                                              : ""
                                          }`}
                                          imageSrc={
                                            getEquipmentCardImageSrc(y?.equipment)
                                          }
                                
                                          iconText={
                                            y?.equipment?.equipmentid
                                              ? "Eq.-Nr " +
                                                y?.equipment?.equipmentid
                                              : ""
                                          }
                                          className=""
                                        />
                                      </Link>
                                    </div>
                                  );
                                })}
                            </>
                          ) : (
                            ""
                          )}
                          {canUserPerformAction(
                            props.profile?.features?.equipment,
                            "create"
                          ) && (
                            <div className={classes.itemcardButtonFooter}></div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </>
            ) : (
              <Typography variant="h1">{i18n.access_denied}</Typography>
            )}
          </Paper>
        // </LazyLoad>
      )}
    </section>
  );
});
